import React from 'react';
import { Link } from 'react-router-dom';
import { Search } from 'lucide-react';

const Navbar = () => {
  return (
    <nav data-testid="main-navbar" className="border-b border-border bg-card">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="flex items-center justify-between h-20">
          <Link to="/" data-testid="nav-logo" className="font-serif text-2xl font-bold tracking-tight text-foreground hover:text-primary smooth-transition">
            ProductPulse
          </Link>
          
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/" data-testid="nav-home" className="text-sm font-medium text-foreground hover:text-primary smooth-transition">
              Home
            </Link>
            <Link to="/reviews" data-testid="nav-reviews" className="text-sm font-medium text-foreground hover:text-primary smooth-transition">
              All Reviews
            </Link>
            <Link to="/categories" data-testid="nav-categories" className="text-sm font-medium text-foreground hover:text-primary smooth-transition">
              Categories
            </Link>
          </div>

          <div className="flex items-center space-x-4">
            <Link to="/search" data-testid="nav-search-btn" className="p-2 hover:bg-muted rounded-sm smooth-transition">
              <Search size={20} />
            </Link>
            <Link
              to="/admin"
              data-testid="nav-admin-link"
              className="text-sm font-medium px-4 py-2 bg-primary text-primary-foreground rounded-sm hover:opacity-90 smooth-transition"
            >
              Admin
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;